import React from 'react';
import { DAY_TIMELINE } from '../../data/homepageLifeSlides';

function DayTimelineSection() {
  return (
    <section className="day-timeline-section">
      <div className="container">
        <h2 className="day-timeline-section__title">Egy nap a Napvirágban</h2>
        <p className="day-timeline-section__subtitle">
          Így telik egy tipikus nap — programokkal, étkezéssel és közös pillanatokkal.
        </p>
        <ol className="day-timeline">
          {DAY_TIMELINE.map((step, index) => (
            <li key={step.time} className="day-timeline__step">
              <span className="day-timeline__icon" aria-hidden>
                {step.icon}
              </span>
              <div className="day-timeline__body">
                <time className="day-timeline__time">{step.time}</time>
                <span className="day-timeline__label">{step.label}</span>
              </div>
              {index < DAY_TIMELINE.length - 1 && (
                <span className="day-timeline__connector" aria-hidden />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default DayTimelineSection;
